<div class="flex h-full items-center">
    <span>{{providerName()}}</span>
    @if (providerResponse()?.fibreBuildingCodesMismatch) {
        <mat-icon 
            class="ml-1 warning-icon" 
            matTooltip="Des codes immeuble différents ont été remontés suite à l'éligibilité technique. Merci d'en vérifier la pertinence et relancer la fiabilisation si nécessaire">
            warning
        </mat-icon>
    }
</div>